import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { discountConfiguration } from "./discount-schemas";

export const updateDiscount = {
  name: "updateDiscount" as const,
  input: z.object({
    _id: zExt.objectId(),
    configuration: discountConfiguration,
  }),
  output: z.null(),
};
